module.exports = __webpack_public_path__ + "img/coin24gold.31672333.svg";